<template>
  <v-card class="mb-1" outlined :key="processMeasureSet.id">
    <v-row no-gutters align="center">
      <v-col cols="1">
        <v-row justify="center">
          <template v-if="processMeasureSet.status === 'OPEN'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-hover>
                  <v-icon
                    v-on="on"
                    slot-scope="{ hover }"
                    v-on:click="toggleProcessMeasureSetStatus(processMeasureSet)"
                    :color="`${hover ? 'primary' : 'gray'}`"
                    >check_circle_outline
                  </v-icon>
                </v-hover>
              </template>
              <span>TOM (mit Bezug auf dieses Verfahren) als erledigt markieren</span>
            </v-tooltip>
          </template>
          <template v-if="processMeasureSet.status === 'COMPLETED'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-hover>
                  <v-icon
                    v-on="on"
                    slot-scope="{ hover }"
                    v-on:click="toggleProcessMeasureSetStatus(processMeasureSet)"
                    :color="`${hover ? 'gray' : 'primary'}`"
                    >check_circle
                  </v-icon>
                </v-hover>
              </template>
              <span>TOM (mit Bezug auf dieses Verfahren) als nicht erledigt markieren</span>
            </v-tooltip>
          </template>
        </v-row>
      </v-col>
      <v-col cols="3">Nr. {{ processMeasureSet.measureSet.seq_nr }} - {{ processMeasureSet.measureSet.type }}</v-col>
      <v-col cols="7"
        ><v-textarea disabled flat solo rows="2" v-model="processMeasureSet.measureSet.description"></v-textarea
      ></v-col>
      <v-col cols="1">
        <v-row justify="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-hover>
                <v-icon
                  class="mr-2"
                  v-on="on"
                  slot-scope="{ hover }"
                  v-on:click="openMeasureSet(processMeasureSet.measureSet)"
                  :color="`${hover ? 'primary' : 'gray'}`"
                  >open_in_new
                </v-icon>
              </v-hover>
            </template>
            <span>Allgemeine TOM anzeigen</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-hover>
                <v-icon
                  v-on="on"
                  slot-scope="{ hover }"
                  v-on:click="deleteProcessMeasureSet()"
                  :color="`${hover ? 'error' : 'gray'}`"
                  >cancel
                </v-icon>
              </v-hover>
            </template>
            <span>Bezug der allgemeinen TOM zu diesem Verfahren entfernen</span>
          </v-tooltip>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { updateProcessMeasureSet, deleteProcessMeasureSet } from "../graphql/mutations";

export default {
  name: "ProcessMeasureSetView",
  props: {
    processMeasureSet: Object,
    companyId: String,
    processTextHeader: String,
  },
  components: {},
  computed: {
    updateProcessMeasureSetMutation() {
      var _processMeasureSet = {};
      Object.assign(_processMeasureSet, this.processMeasureSet);
      _processMeasureSet.measureSet = undefined;
      _processMeasureSet.process = undefined;
      return this.$Amplify.graphqlOperation(updateProcessMeasureSet, { input: _processMeasureSet });
    },
    deleteProcessMeasureSetMutation() {
      return this.$Amplify.graphqlOperation(deleteProcessMeasureSet, { input: { id: this.processMeasureSet.id } });
    },
  },
  mounted() {},
  methods: {
    toggleProcessMeasureSetStatus() {
      this.oldProcessMeasureSet = Object.assign({}, this.processMeasureSet);
      if (this.processMeasureSet.status === "COMPLETED") {
        this.processMeasureSet.status = "OPEN";
      } else {
        this.processMeasureSet.status = "COMPLETED";
      }
      this.updateProcessMeasureSet();
    },
    updateProcessMeasureSet() {
      this.$eventHub.emit("sync-status-syncing");

      this.$Amplify.API.graphql(this.updateProcessMeasureSetMutation)
        .then((response) => {
          this.$recordUpdate(
            this.companyId,
            "PROCESSMEASURESET",
            this.oldProcessMeasureSet,
            this.processMeasureSet,
            (res, err) => {
              res
                ? console.log("logged PROCESSMEASURESET update", res)
                : console.error("error logging PROCESSMEASURESET update", err, e);
            }
          );
          this.onProcessMeasureSetUpdated();
          this.$eventHub.emit("sync-status-success", {
            entity_type: "Verknüpfung von Verfahren",
            entity_label: this.processTextHeader,
            sync_type: "update",
          });
        })
        .catch((err) => {
          this.$eventHub.emit("sync-status-failure", {
            entity_type: "Verknüpfung von Verfahren",
            entity_label: this.processTextHeader,
            sync_type: "update",
            error: err.errors[0].message,
          });
        });
    },
    deleteProcessMeasureSet() {
      this.$eventHub.emit("sync-status-syncing");
      this.$Amplify.API.graphql(this.deleteProcessMeasureSetMutation)
        .then((response) => {
          var processMeasureSet = {
            id: this.processMeasureSet.id,
            status: this.processMeasureSet.status,
            processMeasureSetProcessId: this.processMeasureSet.process.id,
            processMeasureSetMeasureSetId: this.processMeasureSet.measureSet.id,
          };
          this.$recordDelete(this.companyId, "PROCESSMEASURESET", processMeasureSet, (res, err) => {
            res
              ? console.log("logged PROCESSMEASURESET delete", res)
              : console.error("error logging PROCESSMEASURESET delete", err, e);
          });
          this.onProcessMeasureSetDeleted();
          this.$eventHub.emit("sync-status-success", {
            entity_type: "Verknüpfung von Verfahren",
            entity_label: this.processTextHeader,
            sync_type: "delete",
          });
        })
        .catch((err) => {
          this.$eventHub.emit("sync-status-failure", {
            entity_type: "Verknüpfung von Verfahren",
            entity_label: this.processTextHeader,
            sync_type: "delete",
            error: err,
          });
        });
    },
    onProcessMeasureSetUpdated() {
      // from v-bind:key="index" in component. This is the index of this processMeasureSet in list
      var index = this.$vnode.key;
      this.$emit("processMeasureSetUpdated", index);
    },
    onProcessMeasureSetDeleted() {
      this.$emit("processMeasureSetDeleted", this.processMeasureSet);
    },
    openMeasureSet(measureSet) {
      this.$router.push(`/app/company/${this.company_id}/measure/${measureSet.id}`);
    },
  },
  data: () => ({
    oldProcessMeasureSet: null,
  }),
};
</script>
